import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultitaskingLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.89648 21C3.89648 20.5858 4.23227 20.25 4.64648 20.25H19.8541C20.2683 20.25 20.6041 20.5858 20.6041 21C20.6041 21.4142 20.2683 21.75 19.8541 21.75H4.64648C4.23227 21.75 3.89648 21.4142 3.89648 21Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.89648 3C3.89648 2.58579 4.23227 2.25 4.64648 2.25H19.8541C20.2683 2.25 20.6041 2.58579 20.6041 3C20.6041 3.41421 20.2683 3.75 19.8541 3.75H4.64648C4.23227 3.75 3.89648 3.41421 3.89648 3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.84686 7.07031C5.5342 7.07031 4.46875 8.13546 4.46875 9.44939V14.5234C4.46875 15.8371 5.53389 16.9016 6.84686 16.9016H17.6546C18.9687 16.9016 20.0337 15.8369 20.0337 14.5234V9.44939C20.0337 8.13561 18.9684 7.07031 17.6546 7.07031H6.84686ZM2.96875 9.44939C2.96875 7.30733 4.70547 5.57031 6.84686 5.57031H17.6546C19.7969 5.57031 21.5337 7.30718 21.5337 9.44939V14.5234C21.5337 16.666 19.7966 18.4016 17.6546 18.4016H6.84686C4.70577 18.4016 2.96875 16.6658 2.96875 14.5234V9.44939Z",
			fill: "currentColor"
		})
	]
});
export default SvgMultitaskingLine;
